import DefaultDialog from "./Dialog"

export default DefaultDialog